import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import { Eye, EyeOff } from "lucide-react";

const PasswordInput = forwardRef(({ className = "", ...props }, ref) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className="wsm-password-input">
      <input {...props} className={["wsm-input", className].filter(Boolean).join(" ")} ref={ref} type={visible ? "text" : "password"} />
      <button aria-label={visible ? "Hide password" : "Show password"} aria-pressed={visible} onClick={() => setVisible((current) => !current)} type="button">
        {visible ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}
      </button>
    </div>
  );
});

PasswordInput.displayName = "PasswordInput";
PasswordInput.propTypes = { className: PropTypes.string };
export default PasswordInput;
